<template>
  <div v-if="isRouterAlive">
    <Slider :banner="$t('sliderimg')">
      <div class="row align-items-center">
        <div class="col fontsiyuanmedium">
          <div class="slider-title fontsiyuanmedium">
            {{ $t("slidertitle") }}
          </div>
          <div class="slider-subtitle fontsiyuanregular">
            {{ $t("slidersubtitle") }}
          </div>
        </div>
      </div>
    </Slider>
    <div
      class="news-title-wide news-title-group sticky2 row justify-content-center"
      style="text-align: center"
    >
      <div
        :class="`col-lg-1 col-md-2 col-sm-3 col-6 news-title ${
          index == active ? 'active' : ''
        }`"
        @click="change(index)"
        v-for="(item, index) in JSON.parse($t('abouttitlelist'))"
        v-bind:key="index"
      >
        <span> {{ item }}</span>
      </div>
    </div>
    <div class="news-title-thin">
      <b-container>
        <div class="news-title-header" @click="visible1 = !visible1">
          <span class="news-title-title">{{
            JSON.parse($t("abouttitlelist"))[0]
          }}</span>
          <span class="news-title-button"
            ><b-img v-if="!visible1" :src="colarrowdown"></b-img
            ><b-img v-if="visible1" :src="colarrowup"></b-img
          ></span>
        </div>
        <b-collapse
          v-model="visible1"
          class="thin-item-body"
          style="z-index: 1703"
        >
          <div
            class="news-title-header"
            v-for="(item, index) in JSON.parse($t('abouttitlelist'))"
            v-bind:key="index"
          >
            <span class="news-title-title">{{ item }}</span>
          </div>
        </b-collapse>
      </b-container>
    </div>
    <b-container id="about1-0">
      <b-row class="justify-content-md-left about-content-1">
        <b-col cols="10" md="2" lgt="2">
          <span class="about-title">{{
            JSON.parse($t("abouttitlelist"))[3]
          }}</span></b-col
        >
        <b-col cols="12" md="10" lgt="10">
          <div class="row about-content-info">
            <div class="col-10">
              {{ $t("contentt1") }}
            </div>
          </div>

          <div class="row about-content-info">
            <div class="col-10">
              {{ $t("contentt2") }}
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 col-sm-12">
              <b-img
                style="margin-top: 40px"
                src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/study-01.png"
                fluid
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </div>
            <div class="col-md-4 col-sm-12">
              <b-img
                style="margin-top: 40px"
                src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/study-02.png"
                fluid
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </div>
          </div>
          <div
            class="w-100"
            style="
              border-bottom: 0.5px #bdbdbd66 solid;
              height: 10px;
              width: 100%;
              margin-top: 50px;
            "
          ></div>
        </b-col>
      </b-row>
    </b-container>

    <b-container id="about1-1">
      <b-row class="justify-content-md-left about-content-1">
        <b-col cols="10" md="2" lgt="2">
          <span class="about-title">{{
            JSON.parse($t("abouttitlelist"))[4]
          }}</span></b-col
        >

        <!-- <b-col cols="12" md="2" lgt="2">
          <b-img
            class="about-title-bootom"
            src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/aboutteam-05.png"
            fluid
            alt="宁波天鑫仪表有限公司"
          ></b-img>
        </b-col> -->
        <b-col cols="12" md="10" lgt="10">
          <div class="row about-content-info">
            <div class="col-10">
              {{ $t("contentt3") }}
            </div>
          </div>
          <div class="row">
            <div class="col-md-10">
              <b-img
                style="margin-top: 40px"
                src="https://website-1251664918.cos.ap-shanghai.myqcloud.com/%E5%A4%A9%E9%91%AB/study-03.png"
                fluid
                alt="宁波天鑫仪表有限公司"
              ></b-img>
            </div>
          </div>
          <div
            class="w-100"
            style="
              border-bottom: 0.5px #bdbdbd66 solid;
              height: 10px;
              width: 100%;
              margin-top: 50px;
            "
          ></div>
        </b-col>
      </b-row>
    </b-container>

    <Footer class="w-100" />
  </div>
</template>

<script>
import Slider from "../components/slider2";
import Footer from "../components/footer";
import Sticky from "sticky-js";
export default {
  components: {
    Slider,
    Footer,
  },
  data() {
    return {
      active: 3,
      isRouterAlive: true,

      visible1: false,
    };
  },
  computed: {
    colarrowdown() {
      return this.$store.state.colarrowdown;
    },
    colarrowup() {
      return this.$store.state.colarrowup;
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },

    reloadview() {
      const _this = this;
      this.$nextTick(function () {
        switch (
          _this.$route.query.sort ? 99 : parseInt(_this.$route.query.sort)
        ) {
          case 0:
            window.location.href = "/about?sort=0";
            break;
          case 1:
            window.location.href = "/about?sort=1";
            break;
          case 3:
            document.getElementById("about1-0").scrollIntoView();
            break;
          case 4:
            document.getElementById("about1-1").scrollIntoView();
            break;
        }
      });
    },
    change(index) {
      this.active = index;
      switch (parseInt(index)) {
        case 0:
          this.$router.push("/about?sort=0");
          break;
        case 1:
          this.$router.push("/about?sort=1");
          break;
        case 2:
          this.$router.push("/aboutend?sort=2");
          break;
        case 3:
          this.$router.push("/study?sort=3");
          break;
        case 4:
          this.$router.push("/study?sort=4");
          break;
        case 5:
          this.$router.push("/production?sort=5");
          break;
        case 6:
          this.$router.push("/aboutteam?sort=6");
          break;
        case 7:
          this.$router.push("/aboutteam?sort=7");
          break;
        case 8:
          this.$router.push("/aboutteam?sort=8");
          break;
      }
    },
    getAboutPage() {
      const _this = this;
      this.$store.dispatch("getAboutPage").then(({ zh, en }) => {
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);
        let lang = _this.$i18n.locale;
        _this.$i18n.locale = lang;
        _this.reload();
      });
    },
    getAbout3Page() {
      const _this = this;
      this.$store.dispatch("getAbout3Page").then(({ zh, en }) => {
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);
        let lang = _this.$i18n.locale;
        _this.$i18n.locale = lang;
        _this.reload();
        const sticky2 = new Sticky(".sticky2");
        sticky2.update();
      });
    },
  },
  updated() {
    this.reloadview();
  },
  created() {
    this.getAboutPage();
    this.getAbout3Page();
  },
};
</script>
<style>
.slider-title {
  margin-left: 115px;
  color: #fff;
  font-size: 42px;
  font-weight: bold;
}
.slider-subtitle {
  margin-left: 115px;
  color: #fff;
  font-size: 20px;
  font-weight: 100;
}
.news-title-group {
  z-index:1777;
  background-color: #fff;
  border-bottom: 0.5px #bdbdbd88 solid;
}
.news-title {
  padding: 20px 0;
  cursor: pointer;
}
.news-title span {
  padding: 22px 0;
}
.news-title span:hover {
  color: #c00f31;
  font-weight: 800;
  border-bottom: 3px solid #c00f31;
}
.news-title.active span {
  border-bottom: 3px solid #c00f31;
}
.news-title.active {
  color: #c00f31;
  font-weight: 800;
}
.news-list {
  padding-bottom: 100px;
}
.page-item.active .page-link {
  color: #c00f31;
  background-color: #ffffff00;
}
.page-link {
  color: #000;
  border: 0;
}
.page-link:hover {
  color: #c00f31;
}
.pagestyle {
  color: #000;
  padding: 6px 10px;
  border: 0.5px #bdbdbd88 solid;
}
.pagestyle:hover {
  background-color: #00000000;
  color: #c00f31;
}
.page-item:hover {
  background-color: #00000000;
}
.news-pagination {
  margin-top: 100px;
}
.news-item {
  margin-top: 50px;
  cursor: pointer;
}

.news-item:hover {
  -webkit-box-shadow: #00000034 0px 0px 10px;
  -moz-box-shadow: #00000034 0px 0px 10px;
  box-shadow: #00000034 0px 0px 10px;
}
.news-body {
  padding: 10px 30px 20px 30px;
  background-color: #ededed;
}
.product-item-body-head {
  font-size: 12px;
}
.product-item-date {
  font-size: 12px;
  font-weight: 200;
  color: #8a8a8a;
  margin-left: 10px;
}
.product-item-type {
  background-color: #c00f31;
  color: #ffffff;
  padding: 0 5px;
  margin-left: 15px;
}
.news-item-title {
  font-weight: bold;
  font-size: 16px;
  color: #000;
}
.news-item-info {
  margin-top: 30px;
  font-size: 12px;
  color: #8a8a8a;
}
@media only screen and (max-width: 500px) {
  .slider-title {
    margin-left: 65px;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
  }
  .slider-subtitle {
    margin-left: 65px;
    color: #fff;
    font-size: 10px;
    font-weight: 100;
  }
}
.about-content-1 {
  margin-top: 50px;
  margin-bottom: 50px;
}
.about-title {
  font-size: 25px;
  font-weight: bold;
  border-bottom: 2px #c00f31 solid;
  margin-bottom: 50px;
  white-space: nowrap;
}
.about-content-info {
  color: #666666;
  font-weight: 400;
  font-size: 12px;
}

.about-content-info div {
  margin-top: 20px;
}
.about-content-2 {
  min-height: 260px;
  background: url(https://wxapp-1304693027.cos.ap-shanghai.myqcloud.com/test/about/about-bg-01.jpg)
    no-repeat top center scroll;
  background-size: cover;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
}

.about-content-2 img {
  height: 110px;
  margin-top: 40px;
}
.about-img-content {
  background-color: #fff;
  min-height: 220px;
}
.info-title {
  color: #000;
  font-size: 15px;
  font-weight: bold;
}
.b-bg {
  background-color: #ededed;
  text-align: center;
  padding: 50px 0;
  margin-bottom: 30px;
}

.b-bg .slogn {
  font-weight: bold;
}
.b-bg .info {
  font-weight: 200;
}

.news-title-thin {
  display: none;
}
@media only screen and (max-width: 500px) {
  .news-title-wide {
    display: none;
  }
  .news-title-thin {
    display: block;
  }
  .news-title-button img {
    width: 15px;
    position: absolute;
    right: 30px;
  }
  .news-title-header {
    font-size: 15px;
    font-weight: bold;
    padding: 10px 0;
    border-bottom: 1px #bdbdbd44 solid;
  }
}
</style>
